import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import {
  //  Form,
  Control,
  Errors
} from 'react-redux-form';
import { Option } from 'react-select';
import {
  getDefaultErrorMessages,
  // hasValue,
  isValidFaxNumber
} from '@common/validators';
import { TypeAheadComponent } from '@common/components/typeahead/typeahead.component';
import { OptionsViewModel, PageViewModel } from '@models/common.models';
import { EscrowOfficerViewModel, OfficerSearchViewModel } from '@models/EscrowOfficer';
import { EscrowOfficeViewModel, OfficeSearchViewModel } from '@models/EscrowOffice';
import { ModalProps } from '@common/components/modal';
import { EscrowOfficer } from 'src/escrow-officer/_components/escrow-officer/escrow-officer.container';
import { TransactionCoordinatorViewModel, TransactionCoordinatorSearchViewModel } from '@models/TransactionCoordinator';
import { TransactionCoordinator } from 'src/transaction-coordinator/_components/transaction-coordinator/transaction-coordinator.container';
import { parsePhoneNumber } from '@common/parsers';
import { ContractViewModel } from '@models/Contract';
import { DateTimePicker } from '@common/components/date-time-picker/date-time-picker.container';
import { EditPermissions, EditableFields } from '@models/EditPermissions';
import { GetPriceAdjustmentMetadata } from '@models/Product';

export interface EscrowInfoProperties extends RouteComponentProps<{ id?: number }> {
  readonly message: string;
  readonly currentStep: number;
  // readonly buttonRef: (button: HTMLButtonElement) => void;
  readonly contractVM: ContractViewModel;
  readonly toggleModal: (modalProps?: ModalProps) => void;

  readonly lookupEscrowOfficer: (query: string, id: number) => Promise<PageViewModel<OfficerSearchViewModel>>;
  readonly onEscrowOfficerSelect: (model: string, value: number) => void;
  readonly escrowOfficer: EscrowOfficerViewModel;
  readonly escrowOffice: EscrowOfficeViewModel;
  readonly clearEscrowOfficer: () => void;
  readonly isOpenContract?: boolean;
  readonly priceAdjustmentMetaData: GetPriceAdjustmentMetadata;

  readonly lookupTransactionCoordinator: (
    query: string,
    id: number
  ) => Promise<PageViewModel<TransactionCoordinatorSearchViewModel>>;
  readonly onTransactionCoordinatorSelect: (model: string, value: number) => void;
  readonly transactionCoordinators: Array<TransactionCoordinatorViewModel>;
  readonly removeTxC: (id: number) => void;
  readonly assetManagers: Array<OptionsViewModel>;
  readonly getAssetManagers: () => void;
  readonly getTransactionCoordinator: (id?: number) => Promise<void>;
  readonly getContractResaleData: (id: number, date: Date) => void;
  readonly model: string;
  readonly isOrderEdit?: boolean;
  readonly handleEditChange: (
    adjustmentMetaData: GetPriceAdjustmentMetadata,
    propertyTypeId: number,
    saleTypeId: number,
    isRenewal: boolean
  ) => void;
  readonly saveCoe: (coeDate: Date) => void;
}

export class EscrowInfoComponent extends React.Component<EscrowInfoProperties> {
  constructor(props: EscrowInfoProperties) {
    super(props);

    // This binding is necessary to make `this` work in the callback
    this.showEscrowOfficerModal = this.showEscrowOfficerModal.bind(this);
    this.showTransactionCoordinatorModal = this.showTransactionCoordinatorModal.bind(this);
  }

  handleCoe = (resaleDate: Date) => {
    this.props.saveCoe(resaleDate);
    if (this.props.contractVM.resaleId) {
      this.props.getContractResaleData(this.props.contractVM.resaleId, resaleDate);
    }
    if (this.props.isOrderEdit) {
      this.props.handleEditChange(
        this.props.priceAdjustmentMetaData,
        this.props.contractVM.propertyType.id,
        this.props.contractVM.propertySaleType.id,
        false
      );
    }
  };

  componentDidMount() {
    this.props.getAssetManagers();
  }

  renderError() {
    return;
  }

  handleRemoveTxC = (id: number) => (e: React.MouseEvent<HTMLHtmlElement>) => {
    this.props.removeTxC(id);
  };

  loadEscrowOfficer(id: number) {
    this.props.toggleModal();
    this.props.onEscrowOfficerSelect('', id);
  }

  showEscrowOfficerModal() {
    if (this.props.escrowOfficer) {
      this.props.toggleModal({
        title: 'Edit Escrow Officer',
        component: EscrowOfficer,
        saveCallback: this.loadEscrowOfficer.bind(this),
        childProps: { entityId: this.props.escrowOfficer.id }
      });
    } else {
      this.props.toggleModal({
        title: 'Add New Escrow Officer',
        component: EscrowOfficer,
        saveCallback: this.loadEscrowOfficer.bind(this)
      });
    }
  }

  renderEscrowOfficer(eo?: EscrowOfficerViewModel) {
    if (!eo) {
      return;
    }
    return (
      <div className="col-xs-12">
        <div className="row">
          <div className="col-xs-6">
            <label>
              <b>Name</b>
            </label>
            <p>{eo.name}</p>
          </div>
          <div className="col-xs-2">
            <label>
              <b>Phone</b>
            </label>
            <p>{eo.directPhone}</p>
          </div>
          <div className="col-xs-2">
            <label>
              <b>Fax</b>
            </label>
            <p>{eo.directFax}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <label>
              <b>Email Address</b>
            </label>
            <p className="ellipsis">{eo.emailAddress}</p>
          </div>
          <div className="col-xs-6">
            <label>
              <b>Contact Preference</b>
            </label>
            <p>
              <span className="p-10">
                Online Order <i className={eo.onlineOrders ? 'fa fa-check' : 'fa fa-times'} />
              </span>
              <span className="p-10">
                USPS <i className={eo.usps ? 'fa fa-check' : 'fa fa-times'} />
              </span>
              <span className="p-10">
                Fax <i className={eo.fax ? 'fa fa-check' : 'fa fa-times'} />
              </span>
              <span className="p-10">
                Email <i className={eo.email ? 'fa fa-check' : 'fa fa-times'} />
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  }

  renderEscrowOffice(office?: EscrowOfficeViewModel) {
    if (!office) {
      return;
    }
    return (
      <div className="col-xs-12">
        <div className="row">
          <div className="col-xs-6">
            <label>
              <b>Office</b>
            </label>
            <p>
              {office.branch} - {office.company}
            </p>
          </div>
          <div className="col-xs-2">
            <label>
              <b>Office Phone</b>
            </label>
            <p>{office.phone}</p>
          </div>
          <div className="col-xs-2">
            <label>
              <b>Office Fax</b>
            </label>
            <p>{office.fax}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <label>
              <b>Office Address</b>
            </label>
            <p>
              {office.address ? office.address.line1 : ''}
              {office.address && office.address.line2 ? ', ' + office.address!.line2 : ''}
              {', ' +
                (office.address ? office.address.city : '') +
                ', ' +
                (office.address && office.address.state ? office.address.state.abbreviation : '') +
                '  ' +
                (office.address ? office.address.zip : '')}
            </p>
          </div>
        </div>
      </div>
    );
  }

  renderAddClearEscrowOfficer() {
    if (!this.props.escrowOfficer) {
      return (
        <button
          type="button"
          disabled={
            this.props.isOrderEdit && !EditPermissions.CanEditField(EditableFields.Escrow, this.props.isOpenContract)
          }
          className="btn btn-primary mt-15"
          onClick={this.showEscrowOfficerModal}
        >
          Add New Escrow Officer
        </button>
      );
    }
    return (
      <div className="row">
        <div className="col-md-1 mt-15">
          {this.props.isOrderEdit ? (
            EditPermissions.CanEditField(EditableFields.Escrow, this.props.isOpenContract) && (
              <i className="fa fa-times" onClick={this.props.clearEscrowOfficer} />
            )
          ) : (
            <i className="fa fa-times" onClick={this.props.clearEscrowOfficer} />
          )}
        </div>
        <div className="col-md-2 mt-5">
          <button
            className="btn btn-primary"
            disabled={
              this.props.isOrderEdit && !EditPermissions.CanEditField(EditableFields.Escrow, this.props.isOpenContract)
            }
            type="button"
            onClick={this.showEscrowOfficerModal}
          >
            Edit Escrow Officer
          </button>
        </div>
      </div>
    );
  }

  loadTransactionCoordinator = (id: number) => {
    this.props.toggleModal();
    this.props.onTransactionCoordinatorSelect('', id);
  };

  showTransactionCoordinatorModal(id?: number) {
    if (id) {
      this.props.getTransactionCoordinator(id).then(() => {
        this.props.toggleModal({
          title: 'Edit Transaction Coordinator',
          component: TransactionCoordinator,
          saveCallback: () => this.loadTransactionCoordinator(id),
          childProps: { entityId: id }
        });
      });
    } else {
      this.props.toggleModal({
        title: 'Add New Transaction Coordinator',
        component: TransactionCoordinator,
        saveCallback: this.loadTransactionCoordinator
      });
    }
  }

  // handleRemoveTransactionCoordinator = (index: number) => (e: React.MouseEvent<HTMLHtmlElement>) => {
  //   this.props.removeTxC(index);
  // };

  renderTransactionCoordinator(coordinators: Array<TransactionCoordinatorViewModel>) {
    if (coordinators) {
      return coordinators.map((tc, index) => {
        return (
          tc && (
            <div key={index} className="row border-top-bottom mt-5">
              <div className="col-xs-12">
                <div className="row">
                  <div className="col-xs-11 text-right">
                    {this.props.isOrderEdit ? (
                      EditPermissions.CanEditField(EditableFields.TransCoordinator, this.props.isOpenContract) && (
                        <i className="fa fa-times pointer mt-5" onClick={this.handleRemoveTxC(tc.id)} />
                      )
                    ) : (
                      <i className="fa fa-times pointer mt-5" onClick={this.handleRemoveTxC(tc.id)} />
                    )}
                  </div>
                  <div className="col-xs-1">
                    {this.props.isOrderEdit ? (
                      EditPermissions.CanEditField(EditableFields.TransCoordinator, this.props.isOpenContract) && (
                        <i
                          className="fa fa-edit pointer mt-5"
                          onClick={() => this.showTransactionCoordinatorModal(tc.id)}
                        />
                      )
                    ) : (
                      <i
                        className="fa fa-edit pointer mt-5"
                        onClick={() => this.showTransactionCoordinatorModal(tc.id)}
                      />
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-6">
                    <label>
                      <b>Name</b>
                    </label>
                    <p>{tc.name}</p>
                  </div>
                  <div className="col-xs-2">
                    <label>
                      <b>Phone</b>
                    </label>
                    <p>{tc.directPhone}</p>
                  </div>
                  <div className="col-xs-2">
                    <label>
                      <b>Fax</b>
                    </label>
                    <p>{tc.directFax}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-6">
                    <label>
                      <b>Email Address</b>
                    </label>
                    <p className="ellipsis">{tc.emailAddress}</p>
                  </div>
                  <div className="col-xs-12">
                    <p>
                      <span className="p-10">
                        Online Orders <i className={tc.onlineOrders ? 'fa fa-check' : 'fa fa-times'} />
                      </span>
                    </p>
                  </div>
                  <div className="col-xs-6">
                    <label>
                      <b>Contact Preference</b>
                    </label>
                    <p>
                      <span className="p-10">
                        USPS <i className={tc.usps ? 'fa fa-check' : 'fa fa-times'} />
                      </span>
                      <span className="p-10">
                        Fax <i className={tc.fax ? 'fa fa-check' : 'fa fa-times'} />
                      </span>
                      <span className="p-10">
                        Email <i className={tc.email ? 'fa fa-check' : 'fa fa-times'} />
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )
        );
      });
    }
    return;
  }

  render() {
    return (
      <>
        <div className="row pt-10">
          <div className="col-xs-12 dark-gray-bc pb-5">
            <div className="row">
              <div className="col-md-12">
                <h3>Escrow Officer</h3>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-9 mt-5 mb-10">
                <Control.text
                  model=".escrowOfficerId"
                  className="form-control"
                  component={props => {
                    return (
                      <TypeAheadComponent
                        getSuggestions={this.props.lookupEscrowOfficer}
                        disabled={
                          this.props.isOrderEdit &&
                          !EditPermissions.CanEditField(EditableFields.Escrow, this.props.isOpenContract)
                        }
                        renderValue={(
                          opt: Option<{
                            name: string;
                            phone: string;
                            emailAddress: string;
                            address: { city: string | undefined };
                            escrowOffice: OfficeSearchViewModel;
                          }>
                        ) => {
                          return (
                            <div>
                              <div>Name: {opt.name ? opt.name : '-'}</div>
                              <div>Phone #: {opt.phone ? opt.phone : '—'}</div>
                              <div>Email: {opt.emailAddress ? opt.emailAddress : '—'}</div>
                              <div>Office: {opt.escrowOffice ? opt.escrowOffice.name : '—'}</div>
                              <div>
                                Address:{' '}
                                {opt.escrowOffice && opt.escrowOffice!.address ? opt.escrowOffice.address.line1 : '—'}
                              </div>
                              <div>
                                City:{' '}
                                {opt.escrowOffice && opt.escrowOffice!.address ? opt.escrowOffice.address.city : '—'}
                                {opt.escrowOffice && opt.escrowOffice!.address && opt.escrowOffice!.address!.state
                                  ? ', ' + opt.escrowOffice.address.state.abbreviation
                                  : '—'}
                              </div>
                            </div>
                          );
                        }}
                        valueKey={'id'}
                        labelKey={'name'}
                        onChange={props.onChange}
                      />
                    );
                  }}
                  changeAction={this.props.onEscrowOfficerSelect}
                />
                <Errors
                  className="error"
                  model=".escrowOfficerId"
                  show={{ touched: true, focus: false }}
                  messages={getDefaultErrorMessages()}
                />
                <Control.text className="txt-hidden" model=".escrowOfficerId" />
                <Control.text className="txt-hidden" model=".escrowId" />
              </div>
              <div className="col-xs-3">{this.renderAddClearEscrowOfficer()}</div>
            </div>
            <div className="row">{this.renderEscrowOfficer(this.props.escrowOfficer)}</div>
            <div className="row">{this.renderEscrowOffice(this.props.escrowOffice)}</div>
            <div className="row">
              <div className="form-control col-xs-4">
                <label htmlFor={`${this.props.model}.escrowOneTimeFax`}>
                  <b>One Time Fax</b>
                </label>
                <Control.text
                  model=".escrowOneTimeFax"
                  disabled={
                    this.props.isOrderEdit &&
                    !EditPermissions.CanEditField(EditableFields.Escrow, this.props.isOpenContract)
                  }
                  validators={{ isValidFaxNumber }}
                  parser={parsePhoneNumber}
                />
                <Errors
                  className="error"
                  model=".escrowOneTimeFax"
                  show={{ touched: true, focus: false }}
                  messages={getDefaultErrorMessages()}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row pt-10">
          <div className="col-xs-12 dark-gray-bc pb-5">
            <div className="row mt-10">
              <div className="form-control col-xs-6">
                <label htmlFor={`${this.props.model}.fileNumber`}>
                  <b>File Number</b>
                </label>
                <Control.text
                  model=".fileNumber"
                  disabled={
                    this.props.isOrderEdit &&
                    !EditPermissions.CanEditField(EditableFields.Escrow, this.props.isOpenContract)
                  }
                />
                <Errors
                  className="error"
                  model=".fileNumber"
                  show={{ touched: true, focus: false }}
                  messages={getDefaultErrorMessages()}
                />
              </div>
              <DateTimePicker
                modelString=".estimatedCoeDate"
                changeCallback={this.handleCoe}
                label="Est. COE"
                formString={this.props.model}
                className="col-xs-6"
                disabled={
                  this.props.isOrderEdit &&
                  !EditPermissions.CanEditField(EditableFields.Escrow, this.props.isOpenContract)
                }
              />
            </div>
          </div>
        </div>
        <div className="row pt-10">
          <div className="col-xs-12 dark-gray-bc pb-5">
            <div className="row">
              <div className="col-md-12">
                <h3>Transaction Coordinator</h3>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-9 mt-5 mb-10">
                <Control.text
                  model=".transCoordId"
                  className="form-control"
                  disabled={
                    this.props.isOrderEdit &&
                    !EditPermissions.CanEditField(EditableFields.TransCoordinator, this.props.isOpenContract)
                  }
                  component={props => {
                    return (
                      <TypeAheadComponent
                        getSuggestions={this.props.lookupTransactionCoordinator}
                        disabled={
                          this.props.isOrderEdit &&
                          !EditPermissions.CanEditField(EditableFields.TransCoordinator, this.props.isOpenContract)
                        }
                        renderValue={(
                          opt: Option<{
                            name: string;
                            phone: string;
                            emailAddress: string;
                            address: { city: string | undefined };
                            company: OfficeSearchViewModel;
                          }>
                        ) => {
                          return (
                            <div>
                              <div>Name: {opt.name ? opt.name : '-'}</div>
                              <div>Phone #: {opt.phone ? opt.phone : '—'}</div>
                              <div>Email: {opt.emailAddress ? opt.emailAddress : '—'}</div>
                              <div>Office: {opt.company ? opt.company.name : '-'}</div>
                              <div>
                                Address: {opt.company && opt.company!.address ? opt.company.address.line1 : '-'}
                              </div>
                              <div>City: {opt.company && opt.company!.address ? opt.company.address.city : '—'}</div>
                            </div>
                          );
                        }}
                        valueKey={'id'}
                        labelKey={'name'}
                        onChange={props.onChange}
                      />
                    );
                  }}
                  changeAction={this.props.onTransactionCoordinatorSelect}
                />
              </div>
              <div className="col-xs-3">
                <button
                  type="button"
                  className="btn btn-primary mt-15"
                  onClick={() => this.showTransactionCoordinatorModal()}
                  disabled={this.props.isOrderEdit && !EditPermissions.CanEditField(EditableFields.TransCoordinator)}
                >
                  Add New Transaction Coordinator
                </button>
              </div>
            </div>
            {this.renderTransactionCoordinator(this.props.contractVM.transactionCoordinatorIds)}
            <div className="row">
              <div className="form-control col-xs-3">
                <label htmlFor={`${this.props.model}.txCOneTimeFax`}>
                  <b>One Time Fax</b>
                </label>
                <Control.text
                  model=".txCOneTimeFax"
                  validators={{ isValidFaxNumber }}
                  parser={parsePhoneNumber}
                  disabled={
                    this.props.isOrderEdit &&
                    !EditPermissions.CanEditField(EditableFields.TransCoordinator, this.props.isOpenContract)
                  }
                />
                <Errors
                  className="error"
                  model=".txCOneTimeFax"
                  show={{ touched: true, focus: false }}
                  messages={getDefaultErrorMessages()}
                />
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="col-md-11">
            <Errors
              className="error"
              model={`${this.props.model}`}
              show={{ touched: true, focus: false }}
              messages={getDefaultErrorMessages({
                hasEscrowOfficer: 'Escrow Officer is required',
                hasTransactionCoordinator: 'Transaction Coordinator is required'
              })}
            />
            {this.renderError()}
          </div>
        </div>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/escrow-info/escrow-info.component.tsx